import React, { useCallback, useEffect, useState } from "react";
import "./../../Form.scss";
import "./../PedidosForm.scss";
import { useHistory, useParams } from "react-router";
import service from "../../../../services/pedidos";
import serviceCatalogos from "../../../../services/catalogos";
import serviceProdutos from "../../../../services/produtos";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faSave, faTimes, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { hasText } from "../../../../utils/utils";
import { actions as actionsSite } from "../../../../redux/actions/site";
import { useDispatch, useSelector } from "react-redux";
import { datetime2Front } from "../../../../utils/converts";
import { currencyToFloat, formatCurrency } from "../../../../utils/Money";
import { getSituacao } from "./../Pedidos";

const PedidosForm = (props) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.auth.profile);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const params = useParams();
  const [produtos, setProdutos] = useState([]);
  const [catalogos, setCatalogos] = useState([]);
  const [itemPedidos, setItemPedidos] = useState([]);
  const catalogoInicial = "618edaffb1812aa6e681ab46";
  const [pedido, setPedido] = useState({ catalogo: catalogoInicial });
  const { register, handleSubmit, setValue, errors, getValues, setError } = useForm();
  const rota = "pedidos-venda-revendedora";

  const onSubmit = (data) => {
    data.usuario = profile._id;
    data["tipo"] = "Venda";
    data["itemPedidos"] = itemPedidos;
    save(data);
  };

  const carregarPedido = useCallback(async (id) => {
    const pedidoInicial = await service.getById(id);
    setPedido(pedidoInicial);
    setItemPedidos(pedidoInicial.items);
    setLoading(false);
  }, []);

  useEffect(() => {
    //pedido.catalogo = catalogoInicial; //Alteração realizada para que a getInfoProduct() reconheça o catalogo inicial logo na primeira execução
    const run = async () => {
      const _catalogos = serviceCatalogos.get(`?catalogo=NULL&sort=apelido&active=true`);
      const _produtos = serviceProdutos.get(`?active=true`);
      const [_resCatalogos, _resProdutos] = await Promise.all([_catalogos, _produtos]);
     
      setProdutos(_resProdutos.rows);
      setCatalogos(_resCatalogos.rows);
      // setUsuarios(_resUsuarios.rows);
      if (params.id) {
        carregarPedido(params.id);
      } else {
        setLoading(false);
      }
    };
    run();
  }, [carregarPedido, params.id]);

  const save = async (data) => {
    dispatch(actionsSite.setModal(null));
    dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
    const res = await service.upsert(data, pedido._id);
    dispatch(actionsSite.setLoadingMsg(res.msg));
    setTimeout(() => {
      dispatch(actionsSite.setLoadingMsg(""));
      if (data.goToProcess && !res.erro) {
        history.push("/painel/" + rota + "/process/" + res._id);
      } else {
        if (!params.id && !res.erro) {
          history.push("/painel/" + rota);
        }
      }
    }, 3000);
  };

  const baseItemPedidoObj = {
    _id: null,
    produto: "",
    quantidade: "1",
    valor: "0,00",
    desconto: "0.00",
    // outros
    codigo: "",
    descricao: "",
    valorTotal: "0",
  };

  const changeCatalogo = (e) => {
    const _pedido = { ...pedido };
    _pedido.catalogo = e.target.value;
    if (_pedido.catalogo === "618edaffb1812aa6e681ab46") {
      itemPedidos.map((e) => {
        e.desconto = "30.00";
      });
    } else {
      itemPedidos.map((e) => {
        e.desconto = "0.00";
      });
    }
    setPedido(_pedido);
  };

  const optionCatalogos = () => {
    const op = [...catalogos];
    op.sort((a,b)=>a.apelido.toUpperCase() > b.apelido.toUpperCase() ? 1 : -1)
    op.unshift({ _id: "", apelido: "Selecione um catálogo" });
    return op.map((o, i) => {
      return (
        <option key={i} value={o._id}>
          {o.apelido.toUpperCase()}
        </option>
      );
    });
  };

  const renderFormItemPedidos = () => {
    if (itemPedidos.length < 1) {
      addItemPedido();
    }
    return (
      <table cellPadding="0" cellSpacing="0" className="itensPedido">
        <thead>
          <tr>
            <th width="150">Código Produto</th>
            <th width="80">Qtd.</th>
            <th width="80">Tamanho</th>
            <th>Descrição</th>
            <th width="100">Valor Unit.</th>
            {!props.compra && <th width="100">Desc %</th>}
            <th className="total" width="150">
              Valor Total
            </th>
            <th className="acoes" width="100"></th>
          </tr>
        </thead>
        <tbody>
          {itemPedidos.map((e, index) => {
            return (
              <tr key={index}>
                <td>
                  <div className="field">
                    <input
                      name={`codigo${index}`}
                      id={`codigo${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      defaultValue={e.produto.codigo}
                      onChange={(event) => {
                        changeValueField(e, "codigo", event.target.value, resetItemPedidos);
                      }}
                      onBlur={(event) => {
                        getInfoProduct(event.target.value, { index, obj: e });
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="field">
                    <input
                      name={`quantidade${index}`}
                      id={`quantidade${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      value={e.quantidade}
                      onChange={(event) => {
                        changeValueField(e, "quantidade", event.target.value, resetItemPedidos);
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="field">
                    <input
                      name={`tamanho${index}`}
                      id={`tamanho${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      defaultValue={e.tamanho}
                      onChange={(event) => {
                        changeValueField(e, "tamanho", event.target.value, resetItemPedidos);
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="field">
                    <input
                      name={`descricao${index}`}
                      id={`descricao${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      defaultValue={e.produto.nome}
                      onChange={(event) => {
                        changeValueField(e, "descricao", event.target.value, resetItemPedidos);
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="field">
                    <input
                      name={`valor${index}`}
                      id={`valor${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      value={formatCurrency(e.valor)}
                      onChange={(event) => {
                        changeValueMoney(event.target.value, { index, campo: "valor" });
                        changeValueField(e, "valor", currencyToFloat(event.target.value), resetItemPedidos);
                      }}
                    />
                  </div>
                </td>
                {!props.compra && (
                  <td>
                    <div className="field">
                      {/* {formatCurrency(e.desconto)} */}
                      <input
                        name={`desconto${index}`}
                        id={`desconto${index}`}
                        type="text"
                        className={"hasText"}
                        onKeyUp={(e) => hasText(e)}
                        ref={register()}
                        value={formatCurrency(e.desconto)}
                        onChange={(event) => {
                          changeValueMoney(event.target.value, { index, campo: "desconto" });
                          changeValueField(e, "desconto", currencyToFloat(event.target.value), resetItemPedidos);
                        }}
                      />
                    </div>
                  </td>
                )}
                <td>
                  <div className="total">{calculateTotalValue(index)}</div>
                </td>
                <td>
                  <div className="acoes">
                    {buttonAdd(addItemPedido)}
                    {buttonRmv(index, rmvItemPedido)}
                    <input type="hidden" name={`produto${index}`} id={`produto${index}`} defaultValue={e.produto._id} ref={register()} />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const changeValueMoney = (value, args) => {
    const campo = args.campo + args.index;
    const newValue = formatCurrency(value);
    setValue(campo, newValue);
    document.querySelector("#" + args.campo + args.index).classList.add("hasText");
  };

  const calculateTotalValue = (index) => {
    const value = itemPedidos[index].valor;
    const desconto = props.compra ? 0 : ((itemPedidos[index].desconto * itemPedidos[index].valor) / 100).toFixed(2);
    const qty = parseInt(itemPedidos[index].quantidade);
    const total = formatCurrency((value - desconto) * qty);
    return total;
  };

  const getInfoProduct = (codigo, args) => {
    const produto = produtos.find((p) => p.codigo.toUpperCase() === codigo.toUpperCase());
    const descricaoField = `descricao${args.index}`;
    const produtoField = `produto${args.index}`;
    const valorField = `valor${args.index}`;
    if (produto && produto.catalogo == pedido.catalogo) {
      const descricaoValue = `${produto.nome} `;
      const { obj, index } = args;
      obj["descricao"] = descricaoValue;
      obj["produto"] = produto._id;
      obj["valor"] = produto.valor;
      setValue(descricaoField, descricaoValue);
      setValue(produtoField, produto._id);
      setValue(valorField, formatCurrency(produto.valor));
      resetItemPedidos();
    } else {
      const descricaoValue = "";
      const { obj } = args;
      obj["descricao"] = descricaoValue;
      obj["produto"] = "";
      obj["valor"] = "0,00";
      setValue(descricaoField, descricaoValue);
      setValue(produtoField, "");
      setValue(valorField, "0,00");
    }
  };

  const addItemPedido = () => {
    const _itemPedidos = [...itemPedidos];
    if (pedido.catalogo == "618edaffb1812aa6e681ab46") {
      baseItemPedidoObj.desconto = "30.00";
    }
    _itemPedidos.push(baseItemPedidoObj);
    setItemPedidos(_itemPedidos);
  };

  const rmvItemPedido = (index) => {
    const _itemPedidos = [...itemPedidos];
    const obj = _itemPedidos[index];
    if (obj._id && obj._id !== "") {
      openModalRemoveItemPedido(index, obj._id);
    } else {
      rmvItemItemPedido(index);
    }
  };

  const rmvItemItemPedido = (index) => {
    const _itemPedidos = [...itemPedidos];
    _itemPedidos.splice(index, 1);
    setItemPedidos(_itemPedidos);
  };

  const removerItemPedido = async (arg) => {
    const { index, id } = arg;
    dispatch(actionsSite.setModal(null));
    // dispatch(actionsSite.setLoadingMsg("Excluindo item..."));
    // const res = await service.excluirItemPedido(id);
    // dispatch(actionsSite.setLoadingMsg(res.msg));
    // setTimeout(() => {
    rmvItemItemPedido(index);
    //     dispatch(actionsSite.setLoadingMsg(""));
    // }, 3000);
  };
  const resetItemPedidos = () => {
    const _itemPedidos = [...itemPedidos];
    setItemPedidos(_itemPedidos);
  };

  const openModalRemoveItemPedido = (index, id) => {
    const configModal = {
      msg: `Tem certeza que deseja excluir esse item?`,
      title: "Excluir item",
      actions: [{ label: "Sim", class: "azul", callback: removerItemPedido, arg: { index, id } }],
    };

    dispatch(actionsSite.setModal(configModal));
  };

  

  const addBreak = () => {
    return <div className="break"></div>;
  };

  const buttonAdd = (action) => {
    return (
      <div className="field botaoAdd">
        <button type="button" onClick={action}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </div>
    );
  };

  const buttonRmv = (index, action) => {
    return (
      <div className="field botaoRmv">
        <button type="button" onClick={() => action(index)}>
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    );
  };

  const changeValueField = (obj, field, value, cb = null) => {
    obj[field] = value;
    if (cb) {
      cb();
    }
  };

  return (
    <>
      {!loading && (
        <div className="form pedidos">
          <form onSubmit={handleSubmit(onSubmit)} className="formModule branco pedidosForm">
            
              <div className="acoes">
                <button type="submit" className="salvar">
                  <FontAwesomeIcon icon={faSave} /> {params.id ? "Editar" : "Salvar"}
                </button>
                <button type="button" className="cancelar" onClick={() => history.push("/painel/" + rota)}>
                  <FontAwesomeIcon icon={faBan} /> Voltar
                </button>
              </div>
            

            <div className="break mt20"></div>

            {params.id && (
              <>
                <div className="field">
                  <input className={"hasText"} defaultValue={pedido.sequencia} type="text" readOnly />
                  <label>Nº</label>
                </div>
                <div className="field">
                  <input className={"hasText"} defaultValue={getSituacao(pedido)} type="text" readOnly />
                  <label>Situação</label>
                </div>
                {addBreak()}
              </>
            )}

            <div className={errors.catalogo ? "field error" : "field"}>
              <select name="catalogo" className="hasText" ref={register({ required: true })} id="catalogo" value={pedido.catalogo || catalogoInicial} onChange={(e) => changeCatalogo(e)}>
                {optionCatalogos()}
              </select>
              <label htmlFor="catalogo">Catálogo</label>
            </div>
            
            <div className={errors.usuario ? "field error" : "field"}>
                  <input className={"hasText"} name="usuario" id="usuario" type="hidden" readOnly value={profile._id} />
              
                <div className="autocomplete selected">
                  <input className={"hasText"} name="usuarionome" id="usuarionome" type="text" readOnly value={profile.nome} />
                </div>
              
              
              <label htmlFor="valor" className="hasText">
                Revendedora
              </label>
            </div>
            

            

            {!props.compra && params.id && (
              <>
                <div className={errors.createAt ? "field error" : "field"}>
                  <input name="createAt" id="createAt" type="text" className={"hasText"} defaultValue={datetime2Front(pedido.createAt)} readOnly={params.id} />
                  <label htmlFor="createAt">Data</label>
                </div>
              </>
            )}

            <div className="break"></div>
            <h3 className="tituloEtapa mt20">Itens</h3>
            <div className="break"></div>
            {renderFormItemPedidos()}

            <div className="break mt20"></div>
           
              <div className="acoes">
                <button type="submit" className="salvar">
                  <FontAwesomeIcon icon={faSave} /> {params.id ? "Editar" : "Salvar"}
                </button>
                <button type="button" className="cancelar" onClick={() => history.push("/painel/" + rota)}>
                  <FontAwesomeIcon icon={faBan} /> Voltar
                </button>
              </div>
            
            
          </form>
          {errors && Object.keys(errors).length > 0 && (
            <div className="erros">
              <div>
                <FontAwesomeIcon icon={faTimes} /> Existem erros no formulário
              </div>
            </div>
          )}
        </div>
      )}
      {loading && "Carregando..."}
    </>
  );
};

export default PedidosForm;
